// extracted by mini-css-extract-plugin
export var formContainer = "_i0-0";
export var message = "_i0-1";